var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcodes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_659_131226)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.652344,
    width: 36,
    height: 38.5751,
    rx: 18,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0954 27.0477V25.4304H20.6047V27.0477H19.0954ZM17.5861 25.4304V21.3872H19.0954V25.4304H17.5861ZM23.6233 23.0045V19.7699H25.1326V23.0045H23.6233ZM22.114 19.7699V18.1526H23.6233V19.7699H22.114ZM13.0581 21.3872V19.7699H14.5674V21.3872H13.0581ZM11.5488 19.7699V18.1526H13.0581V19.7699H11.5488ZM18.3407 14.1095V12.4922H19.85V14.1095H18.3407ZM12.6808 16.1311H14.9448V13.7051H12.6808V16.1311ZM12.3035 17.344C12.0897 17.344 11.9106 17.2664 11.7662 17.1111C11.6213 16.9564 11.5488 16.7645 11.5488 16.5354V13.3008C11.5488 13.0717 11.6213 12.8795 11.7662 12.7243C11.9106 12.5695 12.0897 12.4922 12.3035 12.4922H15.3221C15.5359 12.4922 15.7153 12.5695 15.8602 12.7243C16.0046 12.8795 16.0768 13.0717 16.0768 13.3008V16.5354C16.0768 16.7645 16.0046 16.9564 15.8602 17.1111C15.7153 17.2664 15.5359 17.344 15.3221 17.344H12.3035ZM12.6808 25.8347H14.9448V23.4088H12.6808V25.8347ZM12.3035 27.0477C12.0897 27.0477 11.9106 26.97 11.7662 26.8148C11.6213 26.6601 11.5488 26.4681 11.5488 26.239V23.0045C11.5488 22.7754 11.6213 22.5832 11.7662 22.4279C11.9106 22.2732 12.0897 22.1958 12.3035 22.1958H15.3221C15.5359 22.1958 15.7153 22.2732 15.8602 22.4279C16.0046 22.5832 16.0768 22.7754 16.0768 23.0045V26.239C16.0768 26.4681 16.0046 26.6601 15.8602 26.8148C15.7153 26.97 15.5359 27.0477 15.3221 27.0477H12.3035ZM21.7367 16.1311H24.0006V13.7051H21.7367V16.1311ZM21.3593 17.344C21.1455 17.344 20.9664 17.2664 20.822 17.1111C20.6771 16.9564 20.6047 16.7645 20.6047 16.5354V13.3008C20.6047 13.0717 20.6771 12.8795 20.822 12.7243C20.9664 12.5695 21.1455 12.4922 21.3593 12.4922H24.378C24.5918 12.4922 24.7709 12.5695 24.9153 12.7243C25.0602 12.8795 25.1326 13.0717 25.1326 13.3008V16.5354C25.1326 16.7645 25.0602 16.9564 24.9153 17.1111C24.7709 17.2664 24.5918 17.344 24.378 17.344H21.3593ZM22.114 27.0477V24.6217H20.6047V23.0045H23.6233V25.4304H25.1326V27.0477H22.114ZM19.0954 21.3872V19.7699H22.114V21.3872H19.0954ZM16.0768 21.3872V19.7699H14.5674V18.1526H19.0954V19.7699H17.5861V21.3872H16.0768ZM16.8314 17.344V14.1095H18.3407V15.7267H19.85V17.344H16.8314ZM13.2468 15.5246V14.3116H14.3788V15.5246H13.2468ZM13.2468 25.2282V24.0153H14.3788V25.2282H13.2468ZM22.3027 15.5246V14.3116H23.4346V15.5246H22.3027Z",
    fill: "url(#paint0_linear_659_131226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_659_131226",
    x: -4.5,
    y: -4.34766,
    width: 46,
    height: 48.5752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_659_131226"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_659_131226",
    result: "effect2_innerShadow_659_131226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_131226",
    x1: 18.3407,
    y1: 9.8722,
    x2: 18.3407,
    y2: 29.3765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodes);
export default __webpack_public_path__ + "static/media/qrcodes.5dfd847a92512565b9d8f3538cdf821f.svg";
export { ForwardRef as ReactComponent };